// Types
export type { NodeConfiguration, RegisteredNode, NodeCategory } from './types';

// Event Node
export { Event, eventConfig } from './nodes/event';
export type { EventNode } from './nodes/event';

// Command Node
export { Command } from './nodes/command';
export type { CommandNode } from './nodes/command';

// Query Node
export { Query } from './nodes/query';
export type { QueryNode } from './nodes/query';

// Service Node
export { Service } from './nodes/service';
export type { ServiceNode } from './nodes/service';

// Channel Node
export { Channel } from './nodes/channel';
export type { ChannelNode } from './nodes/channel';

// Note Node
export { Note } from './nodes/note';
export type { NoteNode } from './nodes/note';

// Data Node
export { Data, dataNodeConfig } from './nodes/data';
export type { DataNode } from './nodes/data';

// View Node
export { View } from './nodes/view';
export type { ViewNode } from './nodes/view';

// Actor Node
export { Actor, actorConfig } from './nodes/actor';
export type { ActorNode } from './nodes/actor';

// External System Node
export { ExternalSystem, externalSystemConfig } from './nodes/external-system';
export type { ExternalSystemNode } from './nodes/external-system';

// NODE TYPES FOR OTHER CONFIGS, TODO: REMOVE THIS IN FUTURE
export { SERVICE, EVENT, QUERY, COMMAND, CHANNEL, ACTOR, MESSAGE, DATA, VIEW } from './nodes/node-types';

// Import for internal use
import { Event } from './nodes/event';
import { eventConfig } from './nodes/event';
import { Command } from './nodes/command';
import { Query } from './nodes/query';
import { Service } from './nodes/service';
import { Channel } from './nodes/channel';
import { Note } from './nodes/note';
import { ExternalSystem } from './nodes/external-system';
import { externalSystemConfig } from './nodes/external-system';
import { Data } from './nodes/data';
import { dataNodeConfig } from './nodes/data';
import { View } from './nodes/view';
import { Actor } from './nodes/actor';
import { actorConfig } from './nodes/actor';

// Node registry helpers
export const nodes = {
  event: {
    component: Event,
    config: eventConfig,
  },
  data: {
    component: Data,
    config: dataNodeConfig,
  },
  actor: {
    component: Actor,
    config: actorConfig,
  },
  externalSystem: {
    component: ExternalSystem,
    config: externalSystemConfig,
  },
};

export const nodeConfigs = {
  event: eventConfig,
  data: dataNodeConfig,
  actor: actorConfig,
  externalSystem: externalSystemConfig,
};

export const nodeComponents = {
  event: Event,
  command: Command,
  query: Query,
  service: Service,
  channel: Channel,
  note: Note,
  externalSystem: ExternalSystem,
  data: Data,
  view: View,
  actor: Actor,
};
